import { render, staticRenderFns } from "./CameraVideo.vue?vue&type=template&id=6dcfb285&scoped=true"
import script from "./CameraVideo.vue?vue&type=script&lang=js"
export * from "./CameraVideo.vue?vue&type=script&lang=js"
import style0 from "./CameraVideo.vue?vue&type=style&index=0&id=6dcfb285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfb285",
  null
  
)

export default component.exports